import React, {useState, useEffect, memo} from 'react'
import {LocationStore} from './LocationStore';
import {getCurrentFiltersValue} from "@/redux/reducers/Default/productList/productListActions";
import {connect, useDispatch} from "react-redux";
import {CALL_API_AND_FRONT_DISPLAY_MODE, FILTER_AVAILABILITY_SHOP_ID_LIST_CODE} from "../../../utils/constants";
import {CHECK_AVAILABILITY_FILTER_DISPLAY} from "@/redux/reducers/Default/actionsTypes";
import {Toggle} from "../../responsive/commun/toggle";

const FilterBar = memo((props) => {
    const {
        availabilityDisplayMode,
        isAvailabilityFilterActif,
        availabilityFilter,
        productListParams,
        shopInfos,
        checkAvailabilityFilterDisplay,
        applyFilters,
        currentFiltersValue,
        handleChangeOptionHT,
        htOptin
    } = props;
    const [showAvailabilityFilter, setShowAvailabilityFilter] = useState(!shopInfos || availabilityFilter?.length > 0)
    const dispatch = useDispatch();
    useEffect(() => {
        props.getCurrentFiltersValue(props.productsListData?.appliedFiltersValues)
    }, [props.productsListData?.appliedFiltersValues]);
    useEffect(() => {
        if (showAvailabilityFilter !== (!shopInfos || availabilityFilter?.length > 0)) {
            setShowAvailabilityFilter(!shopInfos || availabilityFilter?.length > 0)
            dispatch({
                type: CHECK_AVAILABILITY_FILTER_DISPLAY,
                payload: {
                    value: false
                }
            })
        }
    }, [checkAvailabilityFilterDisplay, availabilityFilter])

    const isApplied = (items) => {
        for (let i = 0; i < items.length; i++) {
            if ((items[i][5] == true)) {
                return true
            }
        }
    }
    let seeAllAvailabilityFilter = availabilityFilter?.length > 0 ? availabilityFilter[0][5].filter(item => item[5]) : null
    return (
        <>
            {props.newProductsListData.filters.values != undefined && props.newProductsListData.filters.values.length > 0 ?
                <div className='dp__header__filter-bar'>
                    <div>
                        {availabilityDisplayMode === CALL_API_AND_FRONT_DISPLAY_MODE && isAvailabilityFilterActif && showAvailabilityFilter &&
                            <LocationStore productListParams={productListParams} applyFilters={applyFilters}
                                           availabilityFilter={availabilityFilter}
                                           showAvailabilityFilter={showAvailabilityFilter}
                                           currentFiltersValue={currentFiltersValue}
                                           changeFromClient={productListParams.changeFromClient}/>}

                        <div className='dp__header__filter-bar__filters'>
                            {props.newProductsListData.filters.values != undefined && props.newProductsListData.filters.values.length > 0 &&
                                <ul>
                                    {props.newProductsListData.filters.values.map((itemFilter, index) => {
                                        if (index > 0) {
                                            return (
                                                <li key={index}>
                                                    <button
                                                        type='button'
                                                        className={`dp__header__filter-bar__filters__filter${(isApplied(itemFilter[5]) == true) || (itemFilter[2] == "Slider" && props.newProductsListData.appliedFiltersValues.find(item => item.filterCode == "Prix de référence")) ? "--applied" : ""}`}
                                                        onClick={(event) => (props.filterModal(itemFilter[1]), props.setAccordion(itemFilter[1]))}>
                                                        <span>{itemFilter[0]}</span>
                                                    </button>
                                                </li>
                                            );
                                        }
                                    })}
                                </ul>
                            }
                            <button type="button"
                                    className='dp__header__filter-bar__filters__seeAllFilters'
                                    onClick={(event) => {
                                        props.filterModal(null);
                                        props.setAccordion(null);
                                        appData.actionTrigger.dispatch({
                                            trigger: "seeAllFiltersClicked"
                                        });
                                    }}>
                                Voir tous les filtres
                            </button>
                        </div>
                    </div>
                    <div>
                        <button
                            type="button"
                            className={`dp__header__filter-bar__sort${(props.sortSelected != props.firstRadioSort) ? " dp__header__filter-bar__sort--applied" : ""}`}
                            onClick={(event) => props.filterModal(props.newProductsListData.filters.values[0][1])}>
                            {props.newProductsListData.filters.values[0][0]}
                        </button>
                        {props.productsListData?.showWithoutTaxOptin  &&
                        <div className="dp__header__filter-bar__ht">
                            <div className="dp__header__filter-bar__ht-toggle">
                                <Toggle
                                    checked={htOptin}
                                    size="small"
                                    callBack={(e) => handleChangeOptionHT(e)}
                                    enabled={true}
                                    side="left"
                                    field="htOptin"
                                >
                                    Prix&nbsp;HT
                                </Toggle>
                            </div>
                        </div>
                        }
                    </div>
                </div> : null}
            {(props.newProductsListData.appliedFiltersValues.length > 0) || (props.newProductsListData.currentSort.value != '') ?
                <div className='dp__header__filters-current'>
                    <ul>
                        {props.newProductsListData.currentSort.value != '' ?
                            <li>
                                <button
                                    onClick={(event) => props.removeCurrentSort(event, props.productsListData.currentSort.value)}
                                    className='dp__header__filters-current__remove-filter'
                                    type="button"
                                    aria-label="Supprimer ce filtre">
                                    {props.newProductsListData.currentSort.label}
                                </button>
                            </li>
                            : null
                        }
                        {seeAllAvailabilityFilter?.length > 0 ? <li>
                            <button
                                onClick={(event) => {
                                    event.preventDefault();
                                    props.removeFilter(event, seeAllAvailabilityFilter[0])
                                }}
                                className='dp__header__filters-current__remove-filter'
                                type="button"
                                aria-label="Supprimer ce filtre">
                                Retrait 2h {seeAllAvailabilityFilter[0][4]}
                            </button>
                        </li> : null
                        }
                        {props.newProductsListData.appliedFiltersValues.map((appliedFilters, index) => {
                            let appliedFiltersWithoutKeys = [appliedFilters.filterCode,
                                appliedFilters.label,
                                appliedFilters.code,
                                appliedFilters.value,
                                appliedFilters.unit,
                                appliedFilters.isApplied,
                                appliedFilters.metaInfo,
                                appliedFilters.itemsCount
                            ]
                            if (appliedFilters.filterCode !== FILTER_AVAILABILITY_SHOP_ID_LIST_CODE) {
                                return (
                                    <li key={index}>
                                        <button
                                            onClick={(event) => {
                                                event.preventDefault();
                                                props.removeFilter(event, appliedFiltersWithoutKeys, appliedFilters.filterLabel)
                                            }}
                                            className='dp__header__filters-current__remove-filter'
                                            type="button"
                                            aria-label="Supprimer ce filtre">
                                            {appliedFilters.label} {appliedFilters.unit}
                                        </button>
                                    </li>)
                            }
                            return null
                        })}
                        <li>
                            <button
                                onClick={(event) => props.removeAllFiltersActive(event)}
                                className='dp__header__filters-current__remove-all'
                                type="button"
                                aria-label="Supprimer tous les filtres">
                                Tout effacer
                            </button>
                        </li>
                    </ul>
                </div>
                : null}
        </>
    )
})
const mapStateToProps = (state, ownProps) => {
    return {
        currentFiltersValue: state.productList.currentFiltersValue,
        checkAvailabilityFilterDisplay: state.productList.checkAvailabilityFilterDisplay
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getCurrentFiltersValue: (filters) => dispatch(getCurrentFiltersValue(filters)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBar);
